import { __spreadArray, __read } from './../external_lib/tslib/tslib.es6.js';
function capitalize(str) {
  var words = str.split(' ');
  var capitalizedWords = words.map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });
  return capitalizedWords.join(' ');
}
function extractInitials(str, num) {
  if (num === void 0) {
    num = 1;
  }
  if (!str) {
    return '';
  }
  var words = str.split(' ');
  var initials = '';
  if (words.length > 1) {
    initials = words[0].charAt(0) + (num > 1 ? words[1].charAt(0) : '');
  } else {
    initials = words[0].slice(0, num > 1 ? 2 : 1);
  }
  return initials.toUpperCase();
}
function copyTextToClipboard(text) {
  navigator.clipboard.writeText(text);
}
function getActiveApp(app, active) {
  var _a, _b;
  if (active === void 0) {
    active = [];
  }
  var activeApp = __spreadArray([], __read(active), false);
  if (((_a = app === null || app === void 0 ? void 0 : app.childrenProps) === null || _a === void 0 ? void 0 : _a.length) > 0) {
    activeApp.push(app === null || app === void 0 ? void 0 : app.key);
    return getActiveApp((_b = app === null || app === void 0 ? void 0 : app.childrenProps) === null || _b === void 0 ? void 0 : _b[0], activeApp);
  }
  activeApp.push(app === null || app === void 0 ? void 0 : app.key);
  return activeApp;
}
export { capitalize, copyTextToClipboard, extractInitials, getActiveApp };
//# sourceMappingURL=string.util.js.map
